import script from "./ShareAlbumModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShareAlbumModal.vue?vue&type=script&setup=true&lang=js"

import "./ShareAlbumModal.vue?vue&type=style&index=0&id=216ae7a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-216ae7a0"]])

export default __exports__